"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AspectRatioToJSON = exports.AspectRatioFromJSONTyped = exports.AspectRatioFromJSON = exports.AspectRatio = void 0;
/**
 * String representation of all supported aspect ratios
 * @export
 */
exports.AspectRatio = {
    Horizontal169: 'HORIZONTAL_16_9',
    Horizontal1911: 'HORIZONTAL_1_91_1',
    Horizontal121: 'HORIZONTAL_1_2_1',
    Square: 'SQUARE',
    Vertical916: 'VERTICAL_9_16'
};
function AspectRatioFromJSON(json) {
    return AspectRatioFromJSONTyped(json, false);
}
exports.AspectRatioFromJSON = AspectRatioFromJSON;
function AspectRatioFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AspectRatioFromJSONTyped = AspectRatioFromJSONTyped;
function AspectRatioToJSON(value) {
    return value;
}
exports.AspectRatioToJSON = AspectRatioToJSON;
